module.exports = __webpack_public_path__ + "static/place_icon-66b48cc3baf52cfc970fa76a8b74249e.svg";